module.exports = __webpack_public_path__ + "img/translate.7f3cb41c.png";